import type { SVGProps } from 'react';
import * as tlwIcons from '@trg/icon/tlw';

export type IconName = keyof typeof tlwIcons;

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'> & {
  name: IconName;
  size?: number | string;
};

export function Icon({ name, size = '1em', ...props }: IconProps) {
  const IconComponent = tlwIcons[name];
  return <IconComponent width={size} height={size} {...props} />;
}
